import React from "react";
import { MainAS } from "../AirportService";

export const AirportService = () => {
  return (
    <>
      <MainAS />
    </>
  );
};
